<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-10 md-size-33"></div>
			<div class="md-layout-item md-medium-size-80 md-size-33 middle">
				<img src="@/assets/img/logo-login.png">
				<md-card class="card">
					<md-card-header data-background-color="orange">
						<h4 class="title">ចូលក្នុងប្រព័ន្ធ</h4>
						<p class="category">សូមបញ្ចូលឈ្មោះ និង ពាក្យសំងាត់</p>
					</md-card-header>

					<md-card-content>
						<form @submit.prevent="login()">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>ឈ្មោះអ្នកប្រើប្រាស់</label>
										<md-input v-model="user.username" type="text" @keyup="checkValidation()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>ពាក្យសំងាត់</label>
										<md-input v-model="user.password" type="password" @keyup="checkValidation()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-size-100 text-right">
									<md-button :class="{'md-raised': true, 'md-primary': isValid}" :disabled="!isValid"
										type="submit">ចូលក្នុងប្រព័ន្ធ</md-button>
								</div>
							</div>
						</form>
					</md-card-content>
				</md-card>
				<div style="text-align: center;width: 100%">
					<md-button class="md-just-icon md-simple md-primary" @click="lock()">
						<md-icon>lock</md-icon>
						<md-tooltip md-direction="top">ចាក់សោ</md-tooltip>
					</md-button>
				</div>
			</div>
			<div class="md-layout-item md-medium-size-25 md-size-33"></div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {

			this.$cookie.delete('auth');
		},
		data() {
			return {
				isValid: false,
				user: {
					username: "",
					password: ""
				}
			}
		},
		methods: {
			login() {
				let username = this.user.username
				let password = this.user.password

				this.isValid = false
				this.user.password = ""
				this.checkValidation();

				this.$http.post(this.config.api + "/admin/login", {username, password}).then(res => {

					if (res.body.status == 'success') {
						this.$store.state.authentication.loggedIn = true;
						this.$store.state.authentication.authToken = res.body.data.token;
						this.$store.state.authentication.name = res.body.data.name;
						this.$store.state.authentication.account_type = res.body.data.account_type;
						this.$cookie.set('auth', res.body.data.token, 1);
						this.$cookie.set('name', res.body.data.name, 1);
						this.$cookie.set('account_type', res.body.data.account_type, 1);
					}
				})
				// if (username == 'admin' && password == 'testingtesting') {
				// 	this.$store.state.authentication.loggedIn = true;
				// } else {
				// 	this.$notification.notify({
				// 		message: "Incorrect username or password",
				// 		icon: 'error',
				// 		type: 'danger'
				// 	})
				// }
			},
			checkValidation() {
				if (this.user.username.length > 2 && this.user.password.length > 2) {
					this.isValid = true
				} else {
					this.isValid = false
				}
			},
			lock() {
				this.$store.state.authentication.lock = true;
				this.$cookie.delete('lock');
			}
		}
	}
</script>

<style scoped>
	.card {
		margin-top: 80px;
	}

	.middle {
		position: relative;
		margin-top: 12vh;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue